import React, { useContext} from 'react'
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { getKeyByValue, countryCode } from '../../../utils/country';

const Index = () => {
  const { setOpenAddressModal, selectedAddress, setSelectedAddress } = useContext(AuthContext)


  return (
    <div className="small-modal-wrapper">
      <div className="small-modal-content">
        <span className='close' onClick={() => {
          setOpenAddressModal(false)
          setSelectedAddress(null)
          }}><i className="fal fa-times"></i></span>
          <h2>{selectedAddress?.metadata.type === 'shipping' ? 'Shipping Address' : 'Billing Address'} {selectedAddress?.metadata?.is_primary && <span>Primary</span>} </h2>
          <div className="address-details">
            <div className="first-container">
              <div className="address-content">
                <h5>First and Last Name</h5>
                <h4>{selectedAddress?.first_name}</h4>
              </div>
              <div className="address-content">
                <h5>Department</h5>
                <h4>{selectedAddress?.metadata?.department}</h4>
              </div>
              <div className="address-content">
                <h5>Building</h5>
                <h4>{selectedAddress?.metadata?.building}</h4>
              </div>
              <div className="address-content">
                <h5>Attention To</h5>
                <h4>{selectedAddress?.metadata?.attention_to}</h4>
              </div>
              <div className="address-content">
                <h5>City</h5>
                <h4>{selectedAddress?.city}</h4>
              </div>
              <div className="address-content">
                <h5>Zip Code</h5>
                <h4>{selectedAddress?.postal_code}</h4>
              </div>
            </div>
            <div className="second-container">
            <div className="address-content">
                <h5>Company/Institution</h5>
                <h4>{selectedAddress?.company}</h4>
              </div>
              <div className="address-content">
                <h5>Street Address</h5>
                <h4>{selectedAddress?.address_1}</h4>
              </div>
              <div className="address-content">
                <h5>Lab</h5>
                <h4>{selectedAddress?.metadata?.lab}</h4>
              </div>
              <div className="address-content">
                <h5>Country</h5>
                <h4>{getKeyByValue(countryCode, selectedAddress?.country_code?.toUpperCase())}</h4>
              </div>
              <div className="address-content">
                <h5>State</h5>
                <h4>{selectedAddress?.province}</h4>
              </div>
            </div>
          </div>
          <button className='btn' style={{height:'48px', marginBottom:0}} onClick={() => {
            setOpenAddressModal(false)
            setSelectedAddress(null)
          }}>Okay</button>
      </div>
    </div>
  )
}

export default Index